<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">售后状态</span>
          </label>
          <el-select v-model="editForm.orderstatus" placeholder="请选择" style="width: 100%">
            <el-option label="待处理" value="0"></el-option>
            <el-option label="处理中" value="1"></el-option>
            <el-option label="已处理" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">设备型号</span>
          </label>
          <el-select v-model="editForm.glasstype" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in GlassTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">设备SN</span>
          </label>
          <el-input v-model="editForm.sn"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">售后分类</span>
          </label>
          <el-input v-model="editForm.aftersalestype"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">售后原因</span>
          </label>
          <el-input type="textarea" :rows="5" v-model="editForm.aftersalesinfo"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          默认采用上次的附件，如果附件有改动，请把所有附件都重新上传。
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      GlassTypeOptions:[],
      editForm: {
        id: 0,
        orderstatus: '0',
        glasstype: '',
        sn: '',
        aftersalestype: '',
        aftersalesinfo: '',
        attachment: ''
      }
    }
  },
  mounted () {
    this.GlassTypeOptions = Vue.prototype.FunGetAfterSalesServiceGlasstype()
  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.editForm.id = row.Id
      this.editForm.orderstatus = row.Orderstatus.toString()
      this.editForm.glasstype = row.Glasstype
      this.editForm.sn = row.Sn
      this.editForm.aftersalestype = row.Aftersalestype
      this.editForm.aftersalesinfo = row.Aftersalesinfo
      this.editForm.attachment = row.Attachment

      this.$refs.MultiImgOrPdf.cleardata()
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditAfterSalesServiceOrder()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.editForm.attachment = url
    },
    apiEditAfterSalesServiceOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        orderstatus: that.editForm.orderstatus,
        glasstype: that.editForm.glasstype,
        sn: that.editForm.sn,
        aftersalestype: that.editForm.aftersalestype,
        aftersalesinfo: that.editForm.aftersalesinfo,
        attachment: that.editForm.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditAfterSalesServiceOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
